var _line, _g, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 40,
    x2: 0.499998,
    y2: 88,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_8328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 83V11H34.5H38.5H81V83H28Z",
    fill: "#EADDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 83V11H38.5H42.5H85V83H32Z",
    fill: "#EADDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 85V9H77.6132H77.9905H82V85H77.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 83V11H30.5C30.5 10.3333 31 9 32.5 9C34 9 34.5 10.3333 34.5 11H77V83H24Z",
    fill: "#EADDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 11C34.5 10.3333 34 9 32.5 9C31 9 30.5 10.3333 30.5 11V20.5C30.5 21.1667 31 22.5 32.5 22.5C34 22.5 34.5 21.1667 34.5 20.5V16.5",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.6213,
    y: 25,
    width: 3.70709,
    height: 3.70709,
    transform: "rotate(45 63.6213 25)",
    fill: "#EA5A5A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9749,
    y: 66,
    width: 5.62131,
    height: 5.62131,
    transform: "rotate(45 35.9749 66)",
    fill: "#EA5A5A"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 2.18557e-8,
    x2: 109.5,
    y2: 48,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_8328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(14 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesLetter);
export default __webpack_public_path__ + "static/media/categoriesLetter.247c00e1cfc4d35bcca9a4c748831c94.svg";
export { ForwardRef as ReactComponent };